import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão visual
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const ServicosGravacaoManual = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços de gravação manual";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.servicosGravacaoManual})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Gravação Manual</h1>
          <p>Sua história feita com as mãos.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('gravações manuais')}</h2>
        </article>

        {/* Bloco 1: Joias de Ouro e Prata */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Joias</h3>

            <h4>Gravação em peças de ouro e prata</h4>
            <p>Aplicação de iniciais, datas, símbolos e mensagens em anéis, pingentes, pulseiras e colares.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.gravacaoJoias} alt="Gravação manual em joias" />
          </div>
        </section>

        {/* Bloco 2: Inox e Metais Diversos */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Metais</h3>

            <h4>Gravação em inox e metais diversos</h4>
            <p>Personalização de placas, canetas, utensílios, brindes e objetos metálicos com nomes, marcas e textos.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.gravacaoInox} alt="Gravação em metais diversos" />
          </div>
        </section>

        {/* Bloco 3: Copos Populares e Material Escolar */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Material Escolar</h3>

            <h4>Gravação em copos e itens escolares</h4>
            <p>Aplicação de nomes, símbolos e marcas para identificar e personalizar seus itens do dia a dia.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.gravacaoCopoMaterialEscolar} alt="Gravação em copo popular e material escolar" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de gravações manuais')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de gravação manual')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ServicosGravacaoManual;